<template>
<div>
	<div class="us-con">
		<div class="us-title">关于我们</div>
		<div class="us-desc">
			我们是一家致力于为全球企业提供创新招聘解决方案的科技公司。自成立以来，我们不断突破创新，运用先进的技术为企业招聘提供全面支持。无论是简历筛选、面试安排，还是招聘数据分析，我们的系统都能帮助企业在招聘过程中实现更高效、精准和智能的管理。我们的目标不仅是帮助企业找到合适的人才，更通过技术创新推动招聘行业的变革，让每一位企业客户都能在激烈的市场竞争中脱颖而出。
		</div>
		<div class="us-con-flex">
			<div class="us-con-flex-item">
				<div class="us-con-item-title">
					公司使命
				</div>
				<div class="us-con-item-desc">
					以技术赋能招聘，助力企业腾飞
				</div>
				<div class="us-con-item-desc-text">
					我们的使命是通过智能化技术优化招聘流程，提升企业的招聘效率和质量。我们深知，招聘是企业发展的核心之一，合适的人才是推动公司持续增长和创新的关键。因此，我们致力于通过大数据、AI人工智能等先进技术为企业提供智能招聘解决方案，帮助企业快速识别、筛选和吸引高质量的人才，实现招聘目标与企业发展同步。<br /> 我们相信，通过技术的力量，我们不仅可以简化招聘流程，还能帮助企业提升招聘的精准度和有效性，进而为企业创造更多的商业价值。
				</div>
				<img src="../../assets/icon_shiming.png" class="us-con-item-img"/>
			</div>
			<div class="us-con-flex-item bus-ml20" style="background: #EAF4FF;">
				<div class="us-con-item-title">
					公司愿景
				</div>
				<div class="us-con-item-desc">
					招聘科技领域的领导者
				</div>
				<div class="us-con-item-desc-text">
					我们的愿景是成为招聘领域的技术领导者，不断推动招聘行业的数字化和智能化转型。通过我们的创新解决方案，我们希望为全球各地的企业提供更加精准、高效、个性化的招聘服务。我们坚信，招聘不仅是一个流程，更是一项战略性的投资。未来，我们将继续致力于技术创新，推动行业变革，帮助企业不仅招聘到最合适的人才，还能在全球化竞争中处于有利地位。
				</div>
				<img src="../../assets/icon_yuanjing.png" class="us-con-item-img"/>
			</div>
		</div>
	</div>
	<div class="us-team-con">
		<img src="../../assets/pic_bg01.png" class="us-team-img"/>
		<div class="us-team-con-flex">
			<img src="../../assets/icon_team.png" class="us-team-con-img" alt="团队图片" loading="lazy"/>
			<div class="us-team-con-text">
				<div class="us-team-con-text-title">
					我们的团队
				</div>
				<div class="us-team-con-text-desc">
					我们的团队由一群充满激情、富有创造力且高度专业的成员组成。每一位团队成员都是我们成功的关键。我们拥有来自技术、产品、设计、运营等多个领域的专家，他们共同推动公司的技术创新和业务拓展。<br /><br /> 我们的团队文化注重创新与责任并行，鼓励每一位成员都能发挥自己的创意和能力，持续优化产品与服务。我们提倡开放、互信的工作氛围，尊重每一位成员的想法和意见，合作是我们成功的秘诀。
				</div>
			</div>
		</div>
	</div>
	<div class="us-team-small-con">
		<div class="us-team-con-flex">
			<img src="../../assets/icon_team.png" class="us-team-con-img-small" alt="团队图片" loading="lazy"/>
			<div class="us-team-con-text">
				<div class="us-team-con-text-title">
					我们的团队
				</div>
				<div class="us-team-con-text-desc">
					我们的团队由一群充满激情、富有创造力且高度专业的成员组成。每一位团队成员都是我们成功的关键。我们拥有来自技术、产品、设计、运营等多个领域的专家，他们共同推动公司的技术创新和业务拓展。<br /><br /> 我们的团队文化注重创新与责任并行，鼓励每一位成员都能发挥自己的创意和能力，持续优化产品与服务。我们提倡开放、互信的工作氛围，尊重每一位成员的想法和意见，合作是我们成功的秘诀。
				</div>
			</div>
		</div>
	</div>
	<div class="us-core-value-con">
		<div class="us-core-value-title">我们的核心价值</div>
		<div class="us-core-value-desc">我们秉承以下核心价值观，确保每一次服务都为客户创造最大价值</div>
		<div class="us-core-value-flex">
			<div class="us-core-value-flex-item-one">
				<div class="core-item">
					<div class="core-title">创新驱动</div>
					<div class="core-desc">
						我们相信技术创新是推动招聘行业变革的核心动力。通过不断优化我们的系统，我们为企业提供行业领先的智能招聘解决方案
					</div>
				</div>
			</div>
			<div class="us-core-value-flex-item-two">
				<div class="core-item">
					<div class="core-title">客户至上</div>
					<div class="core-desc">
						客户的需求始终是我们的首要任务。我们专注于为每一位客户提供定制化服务，确保每一个环节都能满足其特定需求，帮助他们实现招聘目标
					</div>
				</div>
			</div>
			<div class="us-core-value-flex-item-three">
				<div class="core-item">
					<div class="core-title">诚信透明</div>
					<div class="core-desc">
						我们始终秉持诚信经营的原则，保证所有合作的透明度和公开性，建立长久的信任关系。我们坚信，合作的基础是互信，只有信任才能创造真正的价值
					</div>
				</div>
			</div>
			<div class="us-core-value-flex-item-four">
				<div class="core-item">
					<div class="core-title">团队合作</div>
					<div class="core-desc">
						我们相信团队合作是公司成功的基石。每一位成员都在自己的岗位上发挥着独特的作用，我们提倡相互支持、共同成长，在团队中实现个人和公司的双赢
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="us-service-con">
		<div class="us-core-value-title">我们的服务</div>
		<div class="us-core-value-desc">我们为全球各行各业的企业提供一整套智能招聘解决方案，帮助企业在招聘过程中实现自动化、智能化管理。我们的产品和服务主要涵盖以下几大领域</div>
		<div class="us-service-flex">
			<div class="us-service-flex-item">
				<div class="display-flex">
					<img src="../../assets/icon_gou.png" class="service-icon"/>
					<div class="service-title">
						智能简历筛选与匹配
					</div>
				</div>
				<div class="service-desc">
					我们的系统运用了先进的AI技术，能够自动筛选和分析简历，根据岗位需求进行精准匹配，减少人工筛选的工作量，提升招聘效率。无论是技术岗、管理岗还是蓝领岗位，我们都能帮助企业找到最合适的候选人
				</div>
				<div class="display-flex">
					<img src="../../assets/icon_gou.png" class="service-icon"/>
					<div class="service-title">
						多平台招聘曝光
					</div>
				</div>
				<div class="service-desc">
					我们通过与微信、抖音、支付宝、快手等主流平台的合作，实现多渠道曝光。招聘岗位信息不仅可以通过传统招聘平台发布，还能通过社交平台、短视频平台等多元渠道进行精准传播，扩大岗位曝光度，吸引更多优质候选人。
				</div>
				<div class="display-flex">
					<img src="../../assets/icon_gou.png" class="service-icon"/>
					<div class="service-title">
						招聘进度实时监控
					</div>
				</div>
				<div class="service-desc">
					通过我们的管理平台，企业可以实时监控招聘进度、候选人反馈、面试安排等招聘数据，及时发现招聘过程中的问题并进行调整。无论是招聘经理还是HR，都可以轻松查看整体招聘状况，确保招聘目标的按时达成。
				</div>
				<div class="display-flex">
					<img src="../../assets/icon_gou.png" class="service-icon"/>
					<div class="service-title">
						定制化服务
					</div>
				</div>
				<div class="service-desc">
					我们深知每个企业的需求都是独特的。因此，我们提供定制化的招聘解决方案，帮助企业根据行业特点、岗位需求、招聘规模等因素，量身定制最适合的招聘方案，确保每一项招聘工作都能高效精准地完成。
				</div>
				<div class="display-flex">
					<img src="../../assets/icon_gou.png" class="service-icon"/>
					<div class="service-title">
						精准招聘数据分析
					</div>
				</div>
				<div class="service-desc">
					我们的系统会根据招聘数据生成详细的报表和分析图表，帮助企业实时掌握招聘效果。通过数据分析，企业能够更好地优化招聘策略，确保每一轮招聘都更加高效和精准。
				</div>
			</div>
			<div class="service-img-con">
				<img src="../../assets/pic_bg02.png" class="service-img"/>
			</div>
		</div>
	</div>
	<div class="zhuanli">
			<div class="zhuanliTitle">
				研发专利
			</div>
			<div class="zhuanliDesc">
				从一行代码到一个系统，我们的技术成果均通过国家软件著作权认证。这些不仅是法律保护，更是对用户安全与品质的承诺。
			</div>
			<div class="zhuanliItemWrap">
				<div class="zhuanliItem">
					<img src="../../assets/01.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/02.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/03.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/04.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/05.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/06.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/07.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/08.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/09.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/10.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/11.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/12.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/13.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/14.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/15.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/16.jpg" class="zhuanliItemImg"/>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>

export default {
		name: 'bus',
		props: {
	},
	data() {
		return {
			list:[1,2,3,4,5,6,7,8,9,10,11,12,13,14],
			show:false,
			itemIndex:4
		};
	},
	created() {
	  
	},
	methods: {
		goItem(mode) {
			if(mode == 'back'){
				this.itemIndex = this.itemIndex - 1;
			} else {
				this.itemIndex = this.itemIndex + 1;
			}
			const index = this.itemIndex;
			const item = this.$refs.content.querySelector(`.item[id="${index}"]`);
			console.log(item);
			if (item) {
				setTimeout(() => {
				  item.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'end' });
				}, 0);
				
			}
		},
		showPop(){
			this.$emit('pop',true);
		},
	}
}
</script>

<style scoped>
@import url('./index.css');
</style>
